import Flickity from 'flickity';
import { gsap, ScrollTrigger, ScrollToPlugin } from '../global/gsap';

const initContentGallery = (section) => {
    // const navButtons = section.querySelectorAll('.js-gallery-nav button');
    // const contentSections = gsap.utils.toArray(section.querySelectorAll('.js-gallery-content'));
    // let navActive = false;
    // let currentSection = null;

    // const toggleButtons = () => {
    //     if (currentSection === 0) {
    //         navButtons[0].classList.add('is-disabled');
    //         navButtons[1].classList.remove('is-disabled');
    //     } else if (currentSection == contentSections.length - 1) {
    //         navButtons[0].classList.remove('is-disabled');
    //         navButtons[1].classList.add('is-disabled');
    //     } else {
    //         navButtons[0].classList.remove('is-disabled');
    //         navButtons[1].classList.remove('is-disabled');
    //     }
    // };

    // // Reuable toggle nav
    // const toggleNav = () => {
    //     if (navActive) {
    //         section.classList.add('nav-active');
    //     } else {
    //         section.classList.remove('nav-active');
    //     }
    // };

    // // Set up scrolltrigger etc
    // const tl = gsap.timeline({
    //     scrollTrigger: {
    //         trigger: section,
    //         start: 'top top',
    //         end: 'bottom 145',
    //         onToggle: (self) => {
    //             navActive = self.isActive;
    //             toggleNav(navActive);
    //         }
    //     }
    // });

    // contentSections.forEach((block) => {
    //     const index = parseInt(block.dataset.index, 10);
    //     ScrollTrigger.create({ // Use ScrollTrigger.create if there is no animation
    //         trigger: block,
    //         start: 'top 50%',
    //         end: 'bottom 50%',
    //         onEnter: () => {
    //             currentSection = index;
    //             toggleButtons();
    //         },
    //         onEnterBack: () => {
    //             currentSection = index;
    //             toggleButtons();
    //         }
    //     });
    // });

    // // Nav button event listeners and jump to logic
    // navButtons.forEach((button) => {
    //     button.addEventListener('click', () => {
    //         const { dir } = button.dataset;

    //         if (button.classList.contains('is-disabled')) {
    //             return;
    //         }

    //         if (dir === 'up') {
    //             gsap.to(window, {
    //                 scrollTo: {
    //                     y: contentSections[currentSection - 1],
    //                     offsetY: -10
    //                 }
    //             });
    //         }

    //         if (dir === 'down') {
    //             gsap.to(window, {
    //                 scrollTo: {
    //                     y: contentSections[currentSection + 1],
    //                     offsetY: -10
    //                 }
    //             });
    //         }
    //     });
    // });

    const londonContentEls = document.querySelectorAll('.js-gallery-content');

    londonContentEls.forEach((content) => {
        const carousel = content.querySelector('.js-gallery-carousel');

        if (carousel) {
            const flickityOptions = {
                cellAlign: 'left',
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                draggable: true,
                setGallerySize: true,
                cellSelector: '.js-slide'
            };

            const flkty = new Flickity(carousel, flickityOptions);
        }
    });
};

export default initContentGallery;
